module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lisa Rogak\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("LISA ROGAK is the author of "), _c('I', [_vm._v("The Dogs of War,")]), _c('I', [_vm._v("The Dogs of Courage, One Big Happy Family, ")]), _vm._v("and "), _c('I', [_vm._v("Cats")]), _c('I', [_vm._v("on the Job")]), _vm._v(", among other titles. She lives in Lebanon, New Hampshire.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/177Gc7n/tc-custom/9781466892545.jpg?1718291523767",
      "alt": "This image is the cover for the book Dogs Who Serve"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dogs Who Serve\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Military Working Dogs have played a vital role in the United States armed forces throughout history. This book is a celebration of their contributions to our nation. In "), _c('i', [_vm._v("Dogs Who Serve")]), _vm._v(", "), _c('i', [_vm._v("New York Times ")]), _vm._v("bestselling author Lisa Rogak profiles these heroic dogs and their handlers in the Army, Navy, Air Force, and even the Coast Guard. She chronicles their path to service, from puppyhood to training, then through their career in the field and on to retirement and adoption. And she showcases them in vivid, full-color photographs that capture the devotion and respect that these amazing canines, their devoted handlers, and fellow soldiers share for one another."), _c('br'), _c('br'), _vm._v("A tribute to America's Military Working Dogs, as well as others serving around the globe, "), _c('i', [_vm._v("Dogs Who Serve ")]), _vm._v("is a heartwarming collection for dog lovers everywhere.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0